export default "__VITE_ASSET__BHD_UgBH__"